/// <amd-module name="NetSuite.ImageTextOverlay.ImageTextOverlayModule"/>
define("NetSuite.ImageTextOverlay.ImageTextOverlayModule", ["require", "exports", "NetSuite.ImageTextOverlay.Instrumentation.Helper", "NetSuite.ImageTextOverlay.ImageTextOverlayCCT"], function (require, exports, Instrumentation_Helper_1, ImageTextOverlayCCT) {
    "use strict";
    return {
        mountToApp: function (container) {
            Instrumentation_Helper_1.InstrumentationHelper.initializeInstrumentation(container);
            ImageTextOverlayCCT.mountToApp(container);
        },
    };
});
